module.exports = __webpack_public_path__ + "img/rongyu_es.807dfe1b.png";